import { Component, ReactNode } from 'react'
import { Heading } from '@/components/ui/Heading'
import { Text } from '@/components/ui/Text'
import { Button } from '@/components/ui/button'
import i18n from '@/i18n'

interface Props { children: ReactNode }
interface State { hasError: boolean; error: Error | null; resetKey: number }

export class CreationFlowErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null, resetKey: 0 }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mx-auto flex flex-col items-center justify-center gap-4 px-4 py-12 text-center">
          <Heading level={2}>{i18n.t('creation.errorTitle', { ns: 'app' })}</Heading>
          <Text size="sm" color="muted">
            {i18n.t('creation.errorBody', { ns: 'app' })}
          </Text>
          <Button
            data-testid="wizard-error-try-again"
            onClick={() => this.setState({ hasError: false, error: null, resetKey: this.state.resetKey + 1 })}
          >
            {i18n.t('creation.tryAgain', { ns: 'app' })}
          </Button>
        </div>
      )
    }
    return <div key={this.state.resetKey}>{this.props.children}</div>
  }
}
